<template>
  <div class="client-summary-info d-flex align-start justify-space-between">
    <template v-for="(item) in userSummaryItems">
      <v-tooltip
        :key="item.key"
        bottom
        :open-delay="500"
        :color="'rgba(0,0,0,0.8)'"
        :z-index="tooltipZIndex"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            class="summary-item d-flex align-center"
            v-on="on"
          >
            <div class="icon">
              <component :is="item.icon" />
            </div>
            <div class="d-flex flex-column align-center">
              <span class="summary-title">{{ item.title }}</span>
              <span v-if="item.type === 'price'" class="summary-value">{{ item.value | amountWithCurrency }}</span>
              <span v-else class="summary-value">{{ item.value }}</span>
            </div>
          </div>
        </template>
        {{ item.description }}
      </v-tooltip>
    </template>
  </div>
</template>

<script>
  import IconMoney from './icons/IconMoney'
  import IconCheck from './icons/IconCheck'
  import IconCart from './icons/IconCart'
  import IconClocks from './icons/IconClocks'
  import IconReviewsStar from './icons/IconReviewsStar'
  import IconSmile from './icons/IconSmile'
  import IconSad from './icons/IconSad'

  export default {
    name: 'ClientSummaryInfo',
    comments: {
      IconMoney,
      IconCheck,
      IconCart,
      IconClocks,
      IconReviewsStar,
      IconSmile,
      IconSad,
    },
    props: {
      client: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        // Карточка клиента открывается и в быстром просмотре заказа: тултип должен быть выше панели состава заказа
        tooltipZIndex: 9999,
        items: [
          {
            key: 'totalOrdersAmount',
            title: 'Заказов на сумму:',
            icon: 'IconMoney',
            type: 'price',
            emptyValue: '0',
            description: 'Сумма всех заказов клиента',
          },
          {
            key: 'ordersAvgAmount',
            title: 'Средний чек:',
            icon: 'IconCheck',
            type: 'price',
            emptyValue: '0',
            description: 'Средняя сумма всех заказов клиента',
          },
          {
            key: 'allCompletedOrdersCount',
            title: 'Заказов:',
            icon: 'IconCart',
            emptyValue: '0',
            description: 'Количество всех заказов клиента',
          },
          {
            key: 'countLateOrders',
            title: 'Опозданий:',
            icon: 'IconClocks',
            emptyValue: '0',
            description: 'Количество всех опозданий доставки заказа',
          },
          {
            key: 'reviewsCount',
            title: 'Отзывов:',
            icon: 'IconReviewsStar',
            emptyValue: '0',
            description: 'Количество всех отзывов клиента',
          },
          {
            key: 'positiveReviewsCount',
            title: 'Доволен:',
            icon: 'IconSmile',
            emptyValue: '0',
            description: 'Количество отзывов клиента с оценкой 5 звезд',
          },
          {
            key: 'negativeReviewsCount',
            title: 'Не доволен:',
            icon: 'IconSad',
            emptyValue: '0',
            description: 'Количество отзывов клиента с оценками 1, 2, 3 звезды',
          },
        ],
      }
    },
    computed: {
      userSummaryItems () {
        return this.items.map(item => ({
          ...item,
          value: this.client[item.key] || item.emptyValue,
        }))
      },
    },
  }
</script>

<style scoped lang="less">
.client-summary-info {
  border-radius: 10px;
  background: #fff3d6;
  padding: 15px 24px;
  margin-bottom: 35px;

  .summary-item {
    margin-right: 20px;

    .media-xl-max({
      margin-right: 10px;
    });

    &:last-child {
      margin-right: 0;
    }

    .icon {
      margin-right: 12px;
      margin-top: 4px;
      .media-xl-max({
        margin-right: 7px;
        svg {
          transform: scale(0.85);
        }
      });
    }

    .summary-title {
      font-weight: 300;
      font-size: 1.12em;
      line-height: 1.2;

      .media-xl-max({
        font-size: 1em;
        margin-bottom: 2px;
      });
    }

    .summary-value {
      font-weight: bold;
      font-size: 1.12em;
      line-height: 1;
      white-space: nowrap;
    }
  }
}
</style>
